import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PiCalendarBlank } from "react-icons/pi";
import "./ai-settings.css";

const OPTIONS = ["7 Days", "15 Days", "Custom"];

const toDateValue = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDateTime = (value) => {
  const date = toDateValue(value);
  return date ? date.toISOString() : "";
};

const addDays = (value, days) => {
  const d = toDateValue(value) || new Date();
  const next = new Date(d);
  next.setDate(next.getDate() + days);
  return next;
};

const getMinDate = (scheduledAt) => {
  const base = toDateValue(scheduledAt) || new Date();
  const d = new Date(base);
  d.setDate(d.getDate() + 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const DateInput = React.forwardRef(({ value, onClick, onChange, onFocus, disabled }, ref) => (
  <button
    type="button"
    className="ais-datepicker-trigger"
    onClick={disabled ? undefined : onClick}
    onFocus={disabled ? undefined : onFocus}
    ref={ref}
    disabled={disabled}
  >
    <span className="ais-datepicker-trigger__icon"><PiCalendarBlank /></span>
    <input
      type="text"
      className="ais-datepicker-trigger__field"
      value={value}
      onChange={disabled ? undefined : onChange}
      onClick={disabled ? undefined : onClick}
      onFocus={disabled ? undefined : onFocus}
      placeholder="DD/MM/YYYY / hh:mm"
      readOnly
      disabled={disabled}
    />
  </button>
));

const AiCampaignExpiry = ({
  selectedOption = "7 Days",
  customDate = null,
  scheduledAt = new Date(),
  onChange,
  disabled = false,
}) => {
  const [selected, setSelected] = useState(selectedOption || "7 Days");
  const [customDateState, setCustomDateState] = useState(toDateValue(customDate));

  useEffect(() => {
    setSelected(selectedOption || "7 Days");
    setCustomDateState(toDateValue(customDate));
  }, [selectedOption, customDate]);

  const emitChange = (option, nextCustomDate = null) => {
    const campaignExpiry =
      option === "Custom"
        ? formatDateTime(nextCustomDate)
        : formatDateTime(addDays(scheduledAt, option === "15 Days" ? 15 : 7));

    if (onChange) {
      onChange({
        option,
        customDate: nextCustomDate,
        campaignExpiry,
      });
    }
  };

  const handleOptionChange = (opt) => {
    if (disabled) return;
    setSelected(opt);
    if (opt !== "Custom") setCustomDateState(null);
    emitChange(opt, opt === "Custom" ? customDateState : null);
  };

  const handleCustomDateChange = (date) => {
    if (disabled) return;
    setCustomDateState(date);
    emitChange("Custom", date);
  };

  return (
    <div className="ais-card">
      <p className="ais-title">Campaign Expiry:</p>
      <div className="ais-radio-row">
        {OPTIONS.map((opt) => (
          <label key={opt} className={`ais-radio-label${disabled ? " disabled" : ""}`}>
            <input
              type="radio"
              name="expiry"
              value={opt}
              checked={selected === opt}
              onChange={() => handleOptionChange(opt)}
              disabled={disabled}
            />
            {opt}
          </label>
        ))}
      </div>
      {selected === "Custom" && (
        <div className="ais-picker-wrap">
          <DatePicker
            selected={customDateState}
            onChange={handleCustomDateChange}
            minDate={getMinDate(scheduledAt)}
            showTimeInput
            timeInputLabel="Time"
            dateFormat="dd/MM/yyyy hh:mm aa"
            disabled={disabled}
            customInput={<DateInput disabled={disabled} />}
            popperPlacement="bottom-start"
          />
        </div>
      )}
    </div>
  );
};

export default AiCampaignExpiry;
